module.exports = __webpack_public_path__ + "img/phone.421c33e9.png";